import { useAdminStats } from '../../hooks/useAdminStats';
import { Spinner } from '../../components/ui/Spinner';

export default function AdminInventarioPage() {
  const { data, isLoading, error } = useAdminStats();

  if (isLoading) return <div className="flex justify-center pt-20"><Spinner size={40} /></div>;
  if (error || !data) return <p className="text-red-400">Error al cargar inventario.</p>;

  const { topDuplicates } = data.inventory;

  return (
    <div>
      <h1 className="text-lg font-semibold text-white mb-4">Inventario</h1>

      <div className="bg-[#1a1a2e] rounded-lg overflow-hidden">
        <div className="px-4 py-3 border-b border-[#2a2a3e]">
          <h2 className="text-sm font-semibold text-white/70">
            Barajitas más duplicadas en la comunidad
          </h2>
        </div>
        {topDuplicates.length === 0 ? (
          <p className="px-4 py-6 text-white/30 text-sm">Sin duplicados registrados aún.</p>
        ) : (
          <table className="w-full text-sm">
            <caption className="sr-only">Barajitas más duplicadas</caption>
            <thead>
              <tr className="border-b border-[#2a2a3e]">
                <th className="text-left px-4 py-3 text-xs font-semibold text-white/40 uppercase tracking-wide">#</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-white/40 uppercase tracking-wide">Barajita</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-white/40 uppercase tracking-wide">Usuarios con duplicado</th>
              </tr>
            </thead>
            <tbody>
              {topDuplicates.map(({ stickerId, count }, idx) => (
                <tr key={stickerId} className="border-b border-[#111122] hover:bg-[#0d0d1c] transition-colors">
                  <td className="px-4 py-3 text-white/30 text-xs">{idx + 1}</td>
                  <td className="px-4 py-3 text-gold-400 font-mono">{stickerId}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div
                        className="h-2 rounded-full bg-gold-400"
                        style={{ width: `${Math.max(8, (count / topDuplicates[0].count) * 120)}px` }}
                      />
                      <span className="text-white/70 font-semibold">{count}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
